import { Component } from '@angular/core';

@Component({
  selector: 'ez-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false,
})
export class UnauthorizedComponent {

}
